<app-inline-notification *ngIf="error | async as error" [type]="'error'">
  <ng-container label i18n>Wystąpił problem</ng-container>
  <ng-container message>{{ error }}</ng-container>
</app-inline-notification>
